import { Property } from "./interfaces";

export const fechaEgreso: Property = {
    title: "Fecha de Egreso",
    type: "string",
    format: "local-date-time"
}